export type OnboardingStepId =
  | 'welcome'
  | 'integrations'
  | 'availability'
  | 'packages'
  | 'contracts'
  | 'review'
  | 'profile'
  | 'services'

export type OnboardingStepStatus = 'pending' | 'current' | 'completed' | 'skipped'

export type OnboardingStepConfig = {
  id: OnboardingStepId
  title: string
  description: string
  icon: string
  optional: boolean
}

export type ICP = {
  id: string
  label: string
  icon: string
  contractTemplate: string
}

export const ONBOARDING_STEPS_CONFIG: OnboardingStepConfig[] = [
  {
    id: 'welcome',
    title: 'steps.welcome.title',
    description: 'steps.welcome.description',
    icon: 'Sparkle',
    optional: false,
  },
  {
    id: 'integrations',
    title: 'steps.integrations.title',
    description: 'steps.integrations.description',
    icon: 'PlugsConnected',
    optional: false,
  },
  {
    id: 'availability',
    title: 'steps.availability.title',
    description: 'steps.availability.description',
    icon: 'Calendar',
    optional: false,
  },
  {
    id: 'packages',
    title: 'steps.packages.title',
    description: 'steps.packages.description',
    icon: 'Package',
    optional: true,
  },
  {
    id: 'contracts',
    title: 'steps.contracts.title',
    description: 'steps.contracts.description',
    icon: 'FileText',
    optional: true,
  },
  {
    id: 'review',
    title: 'steps.review.title',
    description: 'steps.review.description',
    icon: 'CheckCircle',
    optional: false,
  },
]

export const PROFESSIONAL_ONBOARDING_STEPS_CONFIG: OnboardingStepConfig[] = [
  {
    id: 'welcome',
    title: 'professional.steps.welcome.title',
    description: 'professional.steps.welcome.description',
    icon: 'Sparkle',
    optional: false,
  },
  {
    id: 'profile',
    title: 'professional.steps.profile.title',
    description: 'professional.steps.profile.description',
    icon: 'UserCircle',
    optional: false,
  },
  {
    id: 'services',
    title: 'professional.steps.services.title',
    description: 'professional.steps.services.description',
    icon: 'Package',
    optional: true,
  },
  {
    id: 'availability',
    title: 'professional.steps.availability.title',
    description: 'professional.steps.availability.description',
    icon: 'Calendar',
    optional: false,
  },
  {
    id: 'review',
    title: 'professional.steps.review.title',
    description: 'professional.steps.review.description',
    icon: 'CheckCircle',
    optional: false,
  },
]

export const ICP_OPTIONS: ICP[] = [
  {
    id: 'photographer',
    label: 'icp.photographer',
    icon: 'Camera',
    contractTemplate: 'photography',
  },
  {
    id: 'doula',
    label: 'icp.doula',
    icon: 'Heart',
    contractTemplate: 'doula',
  },
  {
    id: 'weddingPlanner',
    label: 'icp.weddingPlanner',
    icon: 'Champagne',
    contractTemplate: 'wedding',
  },
  {
    id: 'makeup',
    label: 'icp.makeup',
    icon: 'PaintBrush',
    contractTemplate: 'makeup',
  },
  {
    id: 'dj',
    label: 'icp.dj',
    icon: 'MusicNotes',
    contractTemplate: 'dj',
  },
  {
    id: 'videographer',
    label: 'icp.videographer',
    icon: 'VideoCamera',
    contractTemplate: 'videography',
  },
  {
    id: 'caterer',
    label: 'icp.caterer',
    icon: 'ForkKnife',
    contractTemplate: 'catering',
  },
  {
    id: 'consultant',
    label: 'icp.consultant',
    icon: 'UserCircle',
    contractTemplate: 'consulting',
  },
  {
    id: 'other',
    label: 'icp.other',
    icon: 'DotsThree',
    contractTemplate: 'generic',
  },
]
